import { render } from "./modal-visualisation.vue?vue&type=template&id=6a2d0278&scoped=true"
import script from "./modal-visualisation.vue?vue&type=script&lang=js"
export * from "./modal-visualisation.vue?vue&type=script&lang=js"

import "./modal-visualisation.vue?vue&type=style&index=0&id=6a2d0278&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2d0278"]])

export default __exports__